<template>
  <div class="my-5 d-block d-md-none">
    <a class="history-back" :href="link">Вернуться</a>
  </div>
</template>

<script>
export default {
  name: "ContentBack",
  props: {
    link: {
      type: String,
      default() {
        return '/sveden'
      }
    }
  }
}
</script>

<style scoped>

</style>